import { EventEmitter, Injectable, } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmmiterService {

  // Silently re-checks nav permissions without triggering loader or nav API re-call
  silentPermissionRefresh = new EventEmitter<void>();

  // Forces the routed micro-app view to destroy/recreate in place (re-reads permission
  // flags on ngOnInit) without tearing down the sidenav/shell around it
  reloadOutlet$ = new Subject<void>();

  updateListingDefault = new EventEmitter<any>();
  updateBusinessName = new EventEmitter<any>();
  regenerateComponent = new EventEmitter<any>();
  editSection = new EventEmitter<any>();
  changeContent = new EventEmitter<any>();
  buttonCick = new EventEmitter<any>();
  addNewSectionCick = new EventEmitter<any>();
  pageLevelEdit = new EventEmitter<any>();
  sendingPageData = new EventEmitter<any>();
  gettingButtonClickValues = new EventEmitter<any>();
  componentPositionMoving = new EventEmitter<any>();
  componentDelete = new EventEmitter<any>();
  saveChanges = new EventEmitter<any>();
  switchBusiness = new EventEmitter<any>();
  sendingNewPageData = new EventEmitter<any>();
  goTosettings = new EventEmitter<any>();
  goToblogs = new EventEmitter<any>();
  goToLeads = new EventEmitter<any>();
  goToDashboard = new EventEmitter<any>();
  goToInvoices = new EventEmitter<any>();
  discardChanges = new EventEmitter<any>();
  pageNameChange = new EventEmitter<any>();
  mobileEditorOpen = new EventEmitter<any>();
  localDiscardChanges = new EventEmitter<any>();
  tabChange = new EventEmitter<any>();
  changeAnimation = new EventEmitter<any>();
  showSaveOption = new EventEmitter<any>();
  logoUpdated = new EventEmitter<any>();
  businessUpdated = new EventEmitter<any>();
  updateSidePanel = new EventEmitter<any>();
  hideBottomNav = new EventEmitter<boolean>();
  backbuttonClicked = new EventEmitter<any>();
  updatingViewEnquiry = new EventEmitter<any>();
  closeEvent = new EventEmitter<any>();
  ticketDetailUpdate = new EventEmitter<any>();
  projectListupdate = new EventEmitter<any>();
  goToClikced = new EventEmitter<any>();
  projectDetails = new EventEmitter<any>();
  favListUpdate = new EventEmitter<any>();
  FavRedirect = new EventEmitter<any>();
  FavRedirect$ = new BehaviorSubject<any>(null);
  workItemTabChange = new EventEmitter<any>();
  isAppointmentInstalled = new EventEmitter<any>();
  closeOnboardingLoaderDialog = new EventEmitter<any>();
  updateProspectDetails = new EventEmitter<any>();
  //  CRM DASHBOARD
  goToClikced$ = new BehaviorSubject<{ view: boolean; name: string } | null>(null);
  //Install Checks
  crmInstalled = new EventEmitter<any>();
  aiWriterCalled = new BehaviorSubject<any>(null);
  aiWriterClosed = new EventEmitter<any>();

  private selectedPipelineFilter = new BehaviorSubject<any>(null);
  pipelinId = this.selectedPipelineFilter.asObservable();

  private appSubject = new BehaviorSubject<any>(null);
  app$ = this.appSubject.asObservable();

  private sendDataSubject = new BehaviorSubject<any>(null);
  sendData$ = this.sendDataSubject.asObservable();

  private onBoardingRedirectSubject = new BehaviorSubject<any>(null);
  onBoardingRedirect$ = this.onBoardingRedirectSubject.asObservable();

  // Lead -> Create Order handoff (CRM lead detail page -> ecommerce create-order page)
  private leadForOrderSubject = new BehaviorSubject<{ leadId: string; name: string; mobile: string } | null>(null);
  leadForOrder$ = this.leadForOrderSubject.asObservable();

  // Appointment liked-products -> Create Order handoff (appointment detail page -> ecommerce
  // create-order page) - same one-shot pattern as leadForOrder$ above, but for an already-known
  // customer (not a lead) plus a pre-built cart instead of just an address prefill.
  private productsForOrderSubject = new BehaviorSubject<{
    customerId: string; name: string; mobile: string; email?: string;
    items: { itemId: string; variantId: string | null; name: string; quantity: number }[];
    groupId: string;
  } | null>(null);
  productsForOrder$ = this.productsForOrderSubject.asObservable();


  constructor() {
  }
  emitApp(app: any) {
    this.appSubject.next(app);
  }
  emitPipelineId(pipelineId: any) {
    this.selectedPipelineFilter.next(pipelineId);
  }
  emitOnBoardingRedirect(data: any) {
    this.onBoardingRedirectSubject.next(data);
  }
  emitData(data: any) {
    this.sendDataSubject.next(data);
  }

  clearData() {
    this.sendDataSubject.next(null); // Clear the stored data
  }

  emitLeadForOrder(data: { leadId: string; name: string; mobile: string }) {
    this.leadForOrderSubject.next(data);
  }

  clearLeadForOrder() {
    this.leadForOrderSubject.next(null);
  }

  emitProductsForOrder(data: {
    customerId: string; name: string; mobile: string; email?: string;
    items: { itemId: string; variantId: string | null; name: string; quantity: number }[];
    groupId: string;
  }) {
    this.productsForOrderSubject.next(data);
  }

  clearProductsForOrder() {
    this.productsForOrderSubject.next(null);
  }

  ngOnDestroy() {
    this.clearData();
  }


}
